import {createAction, props} from '@ngrx/store';
import {StorePagedResponse} from '@app/marketplace/stores/_models/store.interface';

export const STORE_DETAILS = '[Stores-Details] item details';
export const LOADING_STORE_DETAILS = '[Stores-Details] Loading item details';
export const ERROR_STORE_DETAILS = '[Stores-Details] Loaded Error';
export const CANCEL_STORE_DETAILS_REQUEST = '[Stores-Details] Cancel request';
export const LoadingStoreDetailsActions = createAction(
  LOADING_STORE_DETAILS
);
export const CancelRequestStoreDetailsActions = createAction(CANCEL_STORE_DETAILS_REQUEST);
export const StoreDetailsActions = createAction(
  STORE_DETAILS,
  props<{data: any}>()
);
export const ErrorStoreDetailsActions = createAction(ERROR_STORE_DETAILS);
